<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Masa Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/Tables" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth > 380">Masalar</span>
        </b-btn>

        <b-btn class="mr-3" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth > 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Table).length === 0">Hata!</b-alert>

    <b-alert
      show
      variant="info"
      v-if="Object.keys(Table).length > 0"
    >Düzenlenen masa: {{ TableOldName }}</b-alert>

    <form @submit.prevent="SaveTable" v-if="Object.keys(Table).length > 0">
      <b-form-group class="formgroup" label="Salon">
        <b-form-select v-model="Table.PlaceID" :options="PlacesGUI"></b-form-select>
      </b-form-group>

      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in TableGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Table[index]" @keypress.enter.prevent="SaveTable"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        PlaceName: "Salon Adı",
        Name: "Masa Adı",
        Sort: "Sıralama"
      },
      TableOldName: "",
      Table: {},
      TableGUI: {}
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    },
    PlacesGUI() {
      let _Places = [];

      for (let i in this.StoreData.Places) {
        const _Category = this.StoreData.Places[i];

        _Places.push({
          value: _Category.ID,
          text: _Category.Name
        });
      }

      return _Places;
    }
  },
  methods: {
    async Refresh() {
      if (!this.StoreData.Tables) return;
      if (!this.StoreData.Tables[this.ParamID]) return;

      let _Table = Object.assign({}, this.StoreData.Tables[this.ParamID]);

      delete _Table.Session;

      await this.$set(this, "TableOldName", _Table.Name);
      await this.$set(this, "Table", _Table);
      await this.$set(
        this,
        "TableGUI",
        Object.filterKey(
          _Table,
          x => ["ID", "PlaceID", "PlaceName", "PlaceSort"].indexOf(x) === -1
        )
      );
    },
    async SaveTable() {
      await this.$store.dispatch("AddLoading", "SaveTable");

      await Services.Nozich.Send(
        "SaveTable",
        {
          ID: this.ParamID,
          Table: this.Table
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SaveTable");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Tables");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
